<template>
    <div class="center">
        <div id="paypal-button-container"></div>
    </div>
</template>

<script>
    export default {

        name: "PaypalButton",
        props: {
            donation: {
                type: Object,
                required: true
            }
        },
        methods: {
            makeButton(paypal) {
                let that = this;
                console.log(this);
                console.log(that);
                paypal.Buttons({
                    createOrder: function (data, actions) {
                        console.log(this);
                        console.log(that);
                        // This function sets up the details of the transaction, including the amount and line item details.
                        return actions.order.create({
                            purchase_units: [{
                                amount: {
                                    value: '0.01'
                                }
                            }]
                        });
                    },
                    onApprove: function(data, actions) {
                        // This function captures the funds from the transaction.
                        return actions.order.capture().then(function(details) {
                            console.log(details);
                            that.processPayload(details);
                            // This function shows a transaction success message to your buyer.
                        });
                    }
                }).render('#paypal-button-container');
            },
            processPayload(details) {
                const payload = {
                    donation: this.donation,
                    paypalResponse: details
                };
                axios.post('/api/paypal-browser-notify', payload).then(response => {
                    location.assign('/donation-confirmation/' + this.donation.uuid);
                }).catch(error => {
                    console.error(error);
                });
            }
        },
        mounted() {
            this.$loadScript("https://www.paypal.com/sdk/js?client-id=AXNjHpwkelzpTrTPjRm-L5yJGEB3zOJlI0C_sqy-mZZ9cYT4MiCERtDxVdWfz1Ivq1z4_Dw_s9jg60t2")
                .then(() => {
                    // Script is loaded, do something
                    console.log('the script is loaded');
                    this.makeButton(paypal);
                })
                .catch((error) => {
                    // Failed to fetch script
                    console.error(error);
                });
        }
    }
</script>

<style scoped>
.center {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
}
</style>
